// extracted by mini-css-extract-plugin
export default {"sortText":"qrMNwzpIiWQC_q4GB1U3"};